var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPartnerBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-partner"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "partner",
    clipPath: "url(#clip-partner)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6242",
    "data-name": "Group 6242",
    transform: "translate(4.495 4.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6240",
    "data-name": "Group 6240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6182",
    "data-name": "Group 6182",
    transform: "translate(2.82 3.035)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2688",
    "data-name": "Rectangle 2688",
    width: 2.033,
    height: 2.326,
    rx: 1,
    fill: "#497ceb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 2.033,
    height: 2.326,
    rx: 1,
    transform: "translate(3.61)",
    fill: "#497ceb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2690",
    "data-name": "Rectangle 2690",
    width: 2.033,
    height: 2.326,
    rx: 1,
    transform: "translate(0 3.711)",
    fill: "#497ceb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2691",
    "data-name": "Rectangle 2691",
    width: 2.033,
    height: 2.326,
    rx: 1,
    transform: "translate(3.61 3.711)",
    fill: "#497ceb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11172",
    "data-name": "\\u30D1\\u30B9 11172",
    d: "M18.743,48.35h1.773a.724.724,0,0,1,.723.723v2.964a.493.493,0,0,1-.493.493H18.513a.493.493,0,0,1-.493-.493V49.073A.724.724,0,0,1,18.743,48.35Zm1.511.985H19.005v2.21h1.248Z",
    transform: "translate(-13.987 -37.39)",
    fill: "#497ceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11188",
    "data-name": "\\u30D1\\u30B9 11188",
    d: "M6951.8-2829.526h-.985v-14.287a.493.493,0,0,1,.493-.492h10.3v.985H6951.8Z",
    transform: "translate(-6950.81 2844.305)",
    fill: "#497ceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_321",
    "data-name": "\\u7DDA 321",
    d: "M5.744-.015H-.507A.493.493,0,0,1-1-.507.493.493,0,0,1-.507-1H5.744a.493.493,0,0,1,.493.493A.493.493,0,0,1,5.744-.015Z",
    transform: "translate(1 15.162)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_322",
    "data-name": "\\u7DDA 322",
    d: "M-.507,3.927A.493.493,0,0,1-1,3.434V-.507A.493.493,0,0,1-.507-1a.493.493,0,0,1,.493.493V3.434A.493.493,0,0,1-.507,3.927Z",
    transform: "translate(11.346 1)",
    fill: "#377ef3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6241",
    "data-name": "Group 6241",
    transform: "translate(6.404 4.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11189",
    "data-name": "Path 11189",
    d: "M5.927,9.719A2.859,2.859,0,0,0,5.927,4,2.859,2.859,0,0,0,5.927,9.719Zm0-4.766a1.906,1.906,0,0,1,0,3.812A1.906,1.906,0,0,1,5.927,4.953Z",
    transform: "translate(-1.624 -4)",
    fill: "#497ceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11190",
    "data-name": "Path 11190",
    d: "M7.644,19.6a3.924,3.924,0,0,0-.691-.686A4.319,4.319,0,0,0,.019,22.76H.972A3.363,3.363,0,0,1,6.71,19.977a3.522,3.522,0,0,1,.934,2.783H8.6a4.494,4.494,0,0,0-.882-3.069c-.019-.033-.048-.062-.071-.1Z",
    transform: "translate(0 -11.922)",
    fill: "#497ceb"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartnerBlue);
export default __webpack_public_path__ + "static/media/icon_partner_blue.79f349b54d7a0902388166986183368c.svg";
export { ForwardRef as ReactComponent };